import React, { useState, useEffect } from 'react';
import api from '../api';

function Support() {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    api.get('/api/support/my-tickets').then(res => setTickets(res.data));
  }, []);

  const submit = async e => {
    e.preventDefault();
    await api.post('/api/support', { subject, message });
    setSubject('');
    setMessage('');
    const res = await api.get('/api/support/my-tickets');
    setTickets(res.data);
  };

  return (
    <div>
      <h2>Support Center</h2>
      <div className="card" style={{ maxWidth: '600px', marginBottom: '2rem' }}>
        <form onSubmit={submit}>
          <input
            placeholder="Subject"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            required
            style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
          />
          <textarea
            placeholder="Describe your issue"
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
            rows="4"
            style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
          />
          <button type="submit" style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0.75rem 1.5rem', borderRadius: '0.5rem', fontWeight: 500 }}>
            Submit Ticket
          </button>
        </form>
      </div>

      <h3>My Tickets</h3>
      {tickets.length === 0 ? <p>No tickets yet.</p> : (
        <div className="card">
          {tickets.map(t => (
            <div key={t.id} style={{ borderBottom: '1px solid #e2e8f0', padding: '0.75rem 0' }}>
              <strong>{t.subject}</strong> <span style={{ color: t.status === 'open' ? 'orange' : '#10b981' }}>({t.status})</span>
              {t.adminResponse && <p style={{ marginTop: '0.25rem', color: '#475569' }}>Response: {t.adminResponse}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default Support;